// eslint-disable-next-line
export default (value: string) => +value.replace('.', '').replace(',', '.');
